import { Restaurant } from "@/model/entities";
import { restaurantService } from "@/service/restaurantService";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useRestaurant(uid: string, subdomain?: string) {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ["restaurant", uid],
    queryFn: () => subdomain ? restaurantService.fetchRestaurantBySubdomain(subdomain) : restaurantService.fetchRestaurantById(uid),
    enabled: !!uid || !!subdomain,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const updateRestaurant = useMutation({
    mutationFn: (restaurant: Restaurant) => {
      if (!restaurant.id) throw new Error("Restaurant id is required");
      return restaurantService.update(restaurant.id as string, restaurant);
    },
    onSuccess: () => {
      // Optionally refetch or update cache
      qc.invalidateQueries({ queryKey: ["restaurant", uid] });
    },
  });

  const deleteRestaurant = useMutation({
    mutationFn: (id: string) => {
      if (!id) throw new Error("Restaurant id is required");
      return restaurantService.delete(id);
    },
    onSuccess: () => {
      // Optionally refetch or update cache
      qc.invalidateQueries({ queryKey: ["restaurant", uid] });
    },
  });

  return { ...query, updateRestaurant, deleteRestaurant };
}
